export default __webpack_public_path__ + "static/media/product_2.2.4967c9cb.jpg";